import { FormControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function InternationalPhoneNumberValidator(control: FormControl): ValidationErrors | null {
    let regex = /([0-9\s\-]{7,})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/;
    if (control.value) {
        let inputValue = null;
        if (control.value instanceof String) {
            inputValue = control.value.trim();
        } else {
            inputValue = control.value;
        }
        if (!regex.test(inputValue)) {
            return { "invalidPhoneNumber": true };
        }
    }
    return null;
}